import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ParkingGateCodesDashboardQueryKeys } from "modules/ParkingGateCodesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { ParkingGateCode } from "models";

export const useUpdateParkingGateCodeMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: ParkingGateCode) => (await ApiInstance.post("/parking_gate/code/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const parkingGateCodes = typedQueryClient.getQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes);
      if (!parkingGateCodes) return;

      const parkingGateCodeIdx = parkingGateCodes.findIndex(parkingGateCode => parkingGateCode.id === payload.id);
      if (parkingGateCodeIdx === -1) return;

      typedQueryClient.setQueryData(
        ParkingGateCodesDashboardQueryKeys.parkingGateCodes,
        parkingGateCodes.with(parkingGateCodeIdx, { ...parkingGateCodes[parkingGateCodeIdx], ...payload })
      );
    }
  });
